import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CONTENT_TEST_QUERY_KEYS } from '../api/query-keys';
import { deleteContentTest } from '../api/content-test.api';

export const useDeleteContentTest = (workspaceId: string | null | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteContentTest(id),
    onSuccess: () => {
      if (workspaceId) {
        void queryClient.invalidateQueries({ queryKey: CONTENT_TEST_QUERY_KEYS.list(workspaceId) });
      }
    },
  });
};
